import { components } from "react-select";

import { Checkbox } from "../../Checkbox/Checkbox.page";

function Option(props: any) {
  const onOptionHoverCustom = props.selectProps?.onOptionHoverCustom;

  const handleHover = () => {
    onOptionHoverCustom?.(props.data);
  };

  return (
    <components.Option
      {...props}
      innerProps={{
        ...props.innerProps,
        onMouseEnter: (e: any) => {
          props.innerProps?.onMouseEnter?.(e);
          handleHover();
        },
        onMouseMove: (e: any) => {
          props.innerProps?.onMouseMove?.(e);
          handleHover();
        },
        onMouseOver: (e: any) => {
          props.innerProps?.onMouseOver?.(e);
          handleHover();
        },
      }}
    >
      {(props?.isMulti) ? (
        <Checkbox
          classNames={{
            container: "pointer-events-none",
            label: "text-inherit",
          }}
          tabIndex={-1}
          readOnly
          onChange={() => { }}
          checked={props.isSelected}
          label={props.label}
        />
      ) : props.label}
    </components.Option>
  );
}

export default Option;
